<template>
  <div class="w-full lg:w-1/3 h-full flex flex-col">
    <div class="hidden lg:block px-4 py-2 rounded" :class="defaultColorClass">
      <h2 class="flex items-center">
        <span class="text-xl font-bold">
          En aval :
          {{ store.home.done.total }}
        </span>
        <PLink
          :to="{
            name: 'home',
            query: { archived: 'true' },
          }"
          class="ml-auto"
        >
          Mes archivés
        </PLink>
      </h2>
    </div>
    <ul class="bg-grey-850 p-1 rounded lg:mt-1 flex flex-col gap-1 overflow-y-scroll">
      <li v-for="letterFile in letterFiles" :key="letterFile.id">
        <LetterFile :letter-file="letterFile" />
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { PLink } from "@pasta/box-v2";
import LetterFile from "../../components/LetterFile.vue";
import { useLetterFileStore } from "../../stores/letter-file.store";
import { useLetterFileColor } from "../../composable/useLetterFileColor";

const store = useLetterFileStore();
const letterFiles = computed(() => store.home.done.data);

const { defaultColorClass } = useLetterFileColor();
</script>
